import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const Disclaimer = ({ onAccept, onCancel }) => (
  <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-6" data-testid="disclaimer-modal">
    <div className="max-w-2xl w-full glass iridescent-border p-8">
      <div className="flex items-start gap-4 mb-4">
        <AlertTriangle className="h-8 w-8 text-plai-cta shrink-0 mt-1" strokeWidth={1.5} />
        <div>
          <h2 className="font-headings text-3xl uppercase tracking-tight text-white">Warning</h2>
          <p className="font-body text-white/60 text-xs uppercase tracking-[0.2em] mt-1">Read before you generate</p>
        </div>
      </div>
      <p className="font-body text-white/85 text-sm leading-relaxed mb-3">
        This is not a legal service. The document you are about to make is an informational draft.
      </p>
      <p className="font-body text-white/85 text-sm leading-relaxed mb-3">
        You should talk to a real lawyer before you mail it or take any action.
      </p>
      <p className="font-body text-white/85 text-sm leading-relaxed mb-6">
        GO OUTDOORS LLC<sup>TM</sup> is not a law firm and is not responsible for what happens after you print this.
      </p>
      <div className="flex gap-3">
        <button onClick={onCancel} className="btn-ghost flex-1" data-testid="disclaimer-cancel-btn">Cancel</button>
        <button onClick={onAccept} className="btn-primary-cta flex-1" data-testid="disclaimer-accept-btn">I Agree, Continue</button>
      </div>
    </div>
  </div>
);

export default Disclaimer;
